
import { isAvatarSrc, thumbnailMediumBlue } from '@utils/thumbnails'
import { Link } from 'react-router-dom'
import { size } from '@styles/theme'
import styled from '@emotion/styled'

import ProfileNAvigateAvatar from '@elements/ProfileNavigateAvatar'
import { SubscriberIcon } from '@elements/icons/SubscriberIcon'
import { ButtonBase, } from '@mui/material'
import { PostMedia } from './PostMedia'
import {
  PiDotsThreeOutlineVerticalFill,
  PiArrowsClockwiseBold,
} from 'react-icons/pi'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  max-width: 100vw;
  padding: ${size(1.5)};
  padding-bottom: 0;
  font-size: 15px;
  line-height: 20px;
`

const PostBody = styled.div`
  margin-top: ${size(2.5)};
  margin-bottom: ${size(2.5)};
  font-size: 18px;
  line-height: 22px;
  color: rgb(225,225,225);
  letter-spacing: 0.35px;
  white-space: pre-line;
  
  p {
    margin: 0;
    min-height: 22px;
  }
  
  a {
    text-decoration: none;
  }

  color: rgb(225,225,225);
`

const LeftPanel = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-right: ${size(2)};
`

const RightPanel = styled.div`
  overflow: hidden;
  width: 100%;
`

const UserImage = styled.img`
  height: ${size(5)};
  width: ${size(5)};
  border-radius: 100%;
`

const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  letter-spacing: 0.35px;
`

const UserName = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 1;
  overflow: hidden;
  white-space: nowrap;
  letter-spacing: 0.35px;
`

const HeadingActions = styled.div`
  display: flex;
  align-items: center;
  padding-left: ${size(0.25)};
  flex-shrink: 0;
  color: grey;
  letter-spacing: 0.35px;
`

const BaseFullScreenPost = ({
  post,
  user,
  media,
  setPanelWidth,
  panelWidth,
  isRepost,
  reposter,
  handleBodyClick,
  handleThreeDotsClick,
}) => {
  const isAvatar = isAvatarSrc('medium', user?.socialMedia?.thumbnail, user?.defaultAvatar)

  return (
    <Container>
      <div ref={(node) => node && setPanelWidth(node?.clientWidth)} style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <div style={{ display: 'flex', width: '100%' }} >
          <LeftPanel>
            {isRepost && <PiArrowsClockwiseBold fill='grey' size={size(1.75)} style={{ transform: 'rotate(90deg)', alignSelf: 'flex-end', margin: `${size(0.35)} 0 ${size(1.35)} 0` }} />}
            <ProfileNAvigateAvatar
              uuid={user?.uuid}
              src={thumbnailMediumBlue(user?.socialMedia?.thumbnail, user?.defaultAvatar)}
              toNearby={false}
              style={{ height: size(5), width: size(5), filter: isAvatar && 'grayscale(100%) contrast(120%)', }}
            />
          </LeftPanel>
          <RightPanel>
            {isRepost && <Link style={{ color: 'grey', textDecoration: 'none', fontWeight: 700, fontSize: 14, marginBottom: size(1), display: 'flex' }}>{reposter?.displayName} reposted</Link>}
            <Heading>
              <UserName>
                <span style={{ fontWeight: 700 }}>{user?.displayName}</span>
                {user?.isSubscribed && <>&nbsp;<SubscriberIcon size={1.85} /></>}
              </UserName>
              <HeadingActions>
              <ButtonBase onClick={handleThreeDotsClick}>
                  <PiDotsThreeOutlineVerticalFill fill='grey' size={size(2)} style={{ marginLeft: size(1) }} />
                </ButtonBase>
              </HeadingActions>
            </Heading>
            <span style={{ color: 'grey', fontSize: '1rem' }}>@{post?.user?.handle}</span>
          </RightPanel>
        </div>
        {post?.body
          ? <PostBody onClick={handleBodyClick} dangerouslySetInnerHTML={{ __html: post?.body }} />
          : <div style={{ height: size(1.5) }} />
        }
      </div>
      <div style={{ flexGrow: 1, width: '100%' }}>
        <PostMedia
          panelWidth={panelWidth}
          media={media}
        />
      </div>
    </Container>
  )
}

export { BaseFullScreenPost }
